import React, { ReactElement } from 'react';
import { Box } from '@styleseat/ui';
import BodyText from '../BodyText';

type PropsType = {
  label?: string | React.ReactNode;
  color?: string;
  id?: string;
  testID?: string;
};

const Label = ({
  label,
  color,
  id,
  testID,
}: PropsType) => {
  if (!label) {
    return null;
  }
  if (typeof label === 'string') {
    return (
      <Box minHeight={18}>
        <label htmlFor={id}>
          <BodyText
            color={color}
            appearance="small"
            style={{ textTransform: 'none' }}
            testID={testID && `${testID}-label`}
          >
            {label}
          </BodyText>
        </label>
      </Box>
    );
  }

  return label as ReactElement;
};

export default Label;
